export const validateDate = (inputStr: string): boolean => {
  const date = new Date(inputStr.trim());
  return !isNaN(date.getTime());
};

const MM_DD_YYYY_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;

export const validateMmDdYyyyFormat = (value: string): boolean =>
  MM_DD_YYYY_REGEX.test(value);

export const MAX_AGE_YEARS = 120;

export const validateMaxAge = (inputStr: string): boolean => {
  const birthDate = new Date(inputStr.trim());
  if (isNaN(birthDate.getTime())) {
    return false;
  }

  const today = new Date();
  const maxAgeCutoff = new Date(
    Date.UTC(
      today.getUTCFullYear() - MAX_AGE_YEARS,
      today.getUTCMonth(),
      today.getUTCDate(),
    ),
  );

  const birthDateNormalized = new Date(
    Date.UTC(
      birthDate.getUTCFullYear(),
      birthDate.getUTCMonth(),
      birthDate.getUTCDate(),
    ),
  );

  return birthDateNormalized >= maxAgeCutoff;
};

export const validateMinAge = (inputStr: string): boolean => {
  const birthDate = new Date(inputStr.trim());
  if (isNaN(birthDate.getTime())) {
    return false;
  }

  const today = new Date();
  const minAgeCutoff = new Date(
    Date.UTC(
      today.getUTCFullYear() - 18,
      today.getUTCMonth(),
      today.getUTCDate(),
    ),
  );

  const birthDateNormalized = new Date(
    Date.UTC(
      birthDate.getUTCFullYear(),
      birthDate.getUTCMonth(),
      birthDate.getUTCDate(),
    ),
  );

  return birthDateNormalized <= minAgeCutoff;
};

export const validateDateInPast = (inputStr: string): boolean => {
  const birthDate = new Date(inputStr.trim());

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const birthDateNormalized = new Date(birthDate);
  birthDateNormalized.setHours(0, 0, 0, 0);

  return birthDateNormalized < today;
};
